import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDeleteLeadList } from '../hooks/useLeadsQuery';

// Confirmação antes de excluir uma lista (menu do chip e diálogo de gerenciar).
// Se a lista excluída estava selecionada, o LeadsListChips volta para "Todas".
const LeadsDeleteListDialog = ({ list, onClose, onDeleted }) => {
  const { t } = useTranslation();
  const deleteMutation = useDeleteLeadList();

  const handleDelete = () => {
    deleteMutation.mutate(list.uuid, {
      onSuccess: () => {
        onClose();
        onDeleted?.();
      },
    });
  };

  return (
    <Dialog open={Boolean(list)} onClose={onClose}>
      <DialogTitle>{t('leads.lists.deleteConfirmTitle', { name: list?.name })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('leads.lists.deleteConfirmMessage')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('leads.lists.cancel')}</Button>
        <Button color="error" disabled={deleteMutation.isPending} onClick={handleDelete}>
          {t('leads.lists.deleteConfirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadsDeleteListDialog;
